// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export default function RAPDChartLegend() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Typography fontSize="14px">{t("Legend")}</Typography>
      <Grid container display="flex" rowSpacing="8px" columnSpacing="16px">
        <Grid
          item
          container
          xs={12}
          display="flex"
          rowSpacing="8px"
          columnSpacing="16px"
        >
          <Grid item display="flex" alignItems="center" gap="8px">
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: "red",
              }}
            />
            <Typography variant="body2" fontSize="12px">
              {t("Left Eye")}
            </Typography>
          </Grid>
          <Grid item display="flex" alignItems="center" gap="8px">
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: "blue",
              }}
            />
            <Typography variant="body2" fontSize="12px">
              {t("Right Eye")}
            </Typography>
          </Grid>
          <Grid item display="flex" alignItems="center" gap="8px">
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: "green",
                opacity: 0.4,
              }}
            />
            <Typography variant="body2" fontSize="12px">
              {t("Blink")}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
